import React from "react"
import Link from "gatsby-link"
import AboutComponent from "../components/About"
import PricingComponent from "../components/Pricing"
import Layout from "../components/layout"

const PricingPage = () => (
  <Layout>
    <div>
      <meta name="apple-itunes-app" content="app-id=1322754821" />
      <meta name="title" content="Premium - The Views News" />
      <meta
        name="description"
        content="Views Premium is what helps keep Views authentic. Learn all the benefits you get for only $1 per month."
      />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://viewsnews.co/premium" />
      <meta property="og:title" content="Views Premium" />
      <meta
        property="og:description"
        content="Views Premium is what helps keep Views authentic. Learn all the benefits you get for only $1 per month."
      />
      <meta
        property="og:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://viewsnews.co/premium" />
      <meta property="twitter:title" content="Views Premium" />
      <meta
        property="twitter:description"
        content="Views Premium is what helps keep Views authentic. Learn all the benefits you get for only $1 per month."
      />
      <meta
        property="twitter:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />
      <AboutComponent
        image="https://images.unsplash.com/photo-1517093201086-6100dc5af8d4?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=b9a3f541d1d721f70113f6811c660f95"
        title="Views Premium"
        text="Views is an information media. Therefore, we are able to ensure the aunthenticity of our infomration through two pricing plans."
      />
      <div>
        <div className="Cards">
          <h2>
            2 Unique Plans.
            <br />1 Amazing Platform.
          </h2>
        </div>
        <PricingComponent />
      </div>
    </div>
  </Layout>
)

export default PricingPage
